import React, { Component } from 'react'
import styles from "./CtxComp.module.css"
//customize convas 
import CircleCVS from "./CircleCVS"
import RectCVS from "./RectCVS"

//static src
import DELETE_ICON_SRC from "../../static/icons8-delete-64.png"
import SCALE_ICON_SRC from "../../static/icons8-scale-48.png"
// DEFINE
const SHAPE_TYPE = {
    ANCHOR: "CtxCompAnchor",
    RECT: "CtxCompRect",
    CIRCLE: "CtxCompCircle",
    RECT_WRAP: "CtxCompRectWrap",
    CIRCLE_WRAP: "CtxCompCircleWrap",
}

export default class CtxComp extends Component {
    constructor(props) {
        super(props)

        //setting up props.pos, props.color and props.scale
        this.state = {
            top: 0,
            left: 0,
            width: 100,
            height: 100,
            rotate: 0,
            scaleVisible: "hidden"
        }

        //private resource
        this.objInfo = {
            moveFlag: false,
            scaleFlag: false,
            rotateFlag: false,
            originalTop: 0,
            originalLeft: 0,
        }
        this.containerNode = null
        this.hoverTimerInst = null

    }

    getShapeStyle = () => {
        const color = (this.props.color) ? this.props.color : "rgb(15,133,66)"
        var shapeStyle = {
            opacity: (this.props.alpha) ? this.props.alpha : "1",
            backgroundColor: "",
            borderRadius: "",
            border: "",
            borderColor: "",
            transform: `rotate(${this.state.rotate}deg)`,
            clipPath: "",
        }

        if (this.props.shape == SHAPE_TYPE.ANCHOR) {
            shapeStyle.clipPath = "polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)"
            shapeStyle.backgroundColor = color
        }
        if (this.props.shape == SHAPE_TYPE.RECT) {
            shapeStyle.border = ""
            shapeStyle.borderRadius = ""
            shapeStyle.backgroundColor = color
        }

        if (this.props.shape == SHAPE_TYPE.CIRCLE) {
            shapeStyle.border = ""
            shapeStyle.borderRadius = "50%"
            shapeStyle.backgroundColor = color
        }

        if (this.props.shape == SHAPE_TYPE.RECT_WRAP) {
            shapeStyle.outline = "solid 5px"
            shapeStyle.outlineColor = color
            shapeStyle.borderRadius = ""
            shapeStyle.borderColor = color
        }

        if (this.props.shape == SHAPE_TYPE.CIRCLE_WRAP) {
            shapeStyle.outline = "solid 5px"
            shapeStyle.outlineColor = color
            shapeStyle.borderRadius = "50%"
            shapeStyle.borderColor = color
        }

        return shapeStyle
    }
    //handler
    moveEnableTrigger = (e) => {
        this.objInfo.moveFlag = true
        this.objInfo.originalTop = e.pageY - this.state.top
        this.objInfo.originalLeft = e.pageX - this.state.left
    }
    moveDisableTrigger = (e) => {
        this.objInfo.moveFlag = false
    }
    setMousePositionHandler = (e) => {
        const target = e.currentTarget;

        this.objInfo.moveFlag = !this.objInfo.moveFlag

        this.objInfo.originalTop = e.pageY - this.state.top
        this.objInfo.originalLeft = e.pageX - this.state.left
    }
    moveHandler = (e) => {
        if (this.objInfo.moveFlag) {
            const mx = e.pageX
            const my = e.pageY
            const diffX = mx - this.objInfo.originalLeft
            const diffY = my - this.objInfo.originalTop

            this.setState(state => { return { top: diffY, left: diffX } })
        }
    }
    scaleHandler = (e) => {
        if (this.objInfo.scaleFlag) {
            // relative to viewport
            const objX = this.containerNode.getBoundingClientRect().x
            const objY = this.containerNode.getBoundingClientRect().y
            var width = e.clientX - objX - 20
            var height = e.clientY - objY - 20
            // console.log(e.pageX, e.pageY)
            this.setState(state => { return { width: width, height: height } })
        }
    }

    rotateHandler = (e) => {
        this.setState(state => { return { rotate: e.target.value } })
    }

    deleteHandler = (e) => {
        console.log("Delete")
        if (this.props.deleteCallback)
            this.props.deleteCallback(this.props.id)
    }
    hoverInHandler = (e) => {
        if (this.hoverTimerInst)
            clearTimeout(this.hoverTimerInst)
        this.setState(state => { return { scaleVisible: "visible" } })
    }

    hoverOutHandler = (e) => {
        if (this.hoverTimerInst)
            clearTimeout(this.hoverTimerInst)
        this.hoverTimerInst = setTimeout(() => {
            this.setState(state => { return { scaleVisible: "hidden" } }, () => {
                this.objInfo.moveFlag = false
                this.objInfo.scaleFlag = false
                this.objInfo.rotateFlag = false
            })
        }, 1000)
    }
    selectHandler = () => {
        if (this.props.selectCallback)
            this.props.selectCallback(this.props.id)
    }
    //lifecycle
    componentDidMount() {
        document.addEventListener("mousemove", (e) => {
            this.moveHandler(e)
            this.scaleHandler(e)
        })
    }

    render() {
        const style = {
            top: `${this.state.top}px`,
            left: `${this.state.left}px`,
            width: `${this.state.width}px`,
            height: `${this.state.height}px`,
        }
        const visibleStyle = { visibility: this.state.scaleVisible }
        const shapeStyle = this.getShapeStyle()
        return (
            <div id={this.props.id} key={this.props.id} style={style} className={styles.container} ref={(ref) => { this.containerNode = ref }}
                onClick={this.selectHandler}
            >
                <div className={styles.contentStyle} style={shapeStyle}></div>
            </div>
        )
    }
}
